<style lang='less' scoped>
@import '../../../style/common/variable';
.national{display: flex;justify-content: space-around;align-items:center;height:60px;margin: 0;padding: 0;
  li{line-height: 19.42px;list-style: none;cursor: pointer;
    img {vertical-align: bottom;}
  }
}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .national {flex-wrap: wrap;width: 100vw !important;height: .8rem; display: none;
    li{width: 30vw;margin-top: .1rem;}
    li:nth-last-child(-n+2){width: 50vw;}
  }
}
</style>

<template>
  <ul class="national">
    <li v-for="(item, index) in country" :key="index" @click="goDmky(item)">
      <img :src="item.dir" alt="">
      <span>{{item.curnamr}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: '',
  data()
  {
    return {
      country: [
        {curnamr: '中国', dir: 'static/index/flag/china.png', id: 2},
        {curnamr: '泰国', dir: 'static/index/flag/Thailand.png', id: 7},
        {curnamr: '菲律宾', dir: 'static/index/flag/Philippines.png', id: 5},
        {curnamr: '文莱', dir: 'static/index/flag/Brunei.png', id: 8},
        {curnamr: '越南', dir: 'static/index/flag/Vietnam.png', id: 9},
        {curnamr: '新加坡', dir: 'static/index/flag/Singapore.png', id: 6},
        {curnamr: '老挝', dir: 'static/index/flag/Laos.png', id: 10},
        {curnamr: '缅甸', dir: 'static/index/flag/Myanmar.png', id: 11},
        {curnamr: '柬埔寨', dir: 'static/index/flag/Cambodia.png', id: 12},
        {curnamr: '印度尼西亚', dir: 'static/index/flag/Indonesia.png', id: 3},
        {curnamr: '马来西亚', dir: 'static/index/flag/Malaysia.png', id: 4},
        {curnamr: '东帝汶', dir: 'static/index/flag/timorleste.png', id: 13}
      ]
    }
  },
  methods: {
    goDmky(item)
    {
      let url = this.$router.resolve({path: '/Dmky', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/National.vue